import { render, staticRenderFns } from "./tanchuang.vue?vue&type=template&id=79ddc14f&scoped=true&"
import script from "./tanchuang.vue?vue&type=script&lang=js&"
export * from "./tanchuang.vue?vue&type=script&lang=js&"
import style0 from "./tanchuang.vue?vue&type=style&index=0&id=79ddc14f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ddc14f",
  null
  
)

export default component.exports